
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemTitle.toLowerCase().indexOf('Elf on the Shelf Arrival Box'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 
}
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct1 === true) {
  	picker.set('disable', [true, 
      { from: [2020, 8, 10], to: [2025, 10, 19] }, 
      { from: [2025, 10, 27], to: [2025, 10, 27] }, 
      { from: [2025, 11, 2], to: [2045, 9, 7] }
    ]);
    picker.set('min', 2);   
    picker.set('max', 100);   
  }	else {
    picker.set('disable', blackoutdatesCollection);
  }  
}

var crDeliveryDateCallback = function(picker, blackoutdatesCollection){
  if (specialProduct1 === true) {
  	picker.set('disable', [true, 
      { from: [2020, 8, 10], to: [2025, 10, 19] }, 
      { from: [2025, 10, 27], to: [2025, 10, 27] }, 
      { from: [2025, 11, 2], to: [2045, 9, 7] }
    ]);
    picker.set('min', 2);   
    picker.set('max', 100);   
  }		else {
    //picker.set('disable', [ [2020, 10, 24], [2020, 10, 25] ]);
    //picker.set('disable', blackoutdatesCollection);   
    picker.set('disable', blackoutdatesCollection);
  }  
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if(selectedDate.getDate() === 26 && selectedMonth === 4 && selectedDate.getFullYear() === 2025) {  	    
    timepicker.set('max',[15, 0]);     
  }
  
  if(selectedDate.getDate() === 27 && selectedMonth === 5 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[19, 0]); 
    timepicker.set('interval', 60);
  }

  if(selectedDate.getDate() === 28 && selectedMonth === 5 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[19, 0]); 
    timepicker.set('interval', 60);
  }

  if(selectedDate.getDate() === 29 && selectedMonth === 5 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[19, 0]); 
    timepicker.set('interval', 60);
  }

  if(selectedDate.getDate() === 4 && selectedMonth === 6 && selectedDate.getFullYear() === 2025) {  	    
    timepicker.set('max',[15, 0]);     
  }

  if(selectedDate.getDate() === 1 && selectedMonth === 8 && selectedDate.getFullYear() === 2025) {  	    
    timepicker.set('max',[15, 0]);     
  }
}

